import { render, staticRenderFns } from "./InputRichTextEditor.vue?vue&type=template&id=66da787c&"
import script from "./InputRichTextEditor.vue?vue&type=script&lang=ts&"
export * from "./InputRichTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./InputRichTextEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports